module.exports = __webpack_public_path__ + "static/media/iPhone.44c1c51c.jpg";